import "./App.css";
import React, { Fragment } from "react";

import Header from "./components/Header";
import Main from "./components/Main";

function App() {
  return (
    <Fragment>
      <Header />
      <Main />
    </Fragment>
  );
}

export default App;
